import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ZTextBox from '../textbox/ZTextBox'
import { emailValidator, alphaValidatorWithLabel, alphaValidator } from '../../utils/ValidationFunction';
import ZGrid from '../grid/ZGrid';
import Networking from '../../utils/api/ApiAccess';
import ApiValues from '../../utils/api/ApiValues';
import localStorage from '../../utils/commonFunction/LocalStorage'
import ZButton from '../button/ZButton';
import { makeStyles } from '@material-ui/core/styles';
import Labels from '../../utils/constants/ConstantEng'
import ZHeader from '../header/ZHeader'
import ToolTipLabels from '../../utils/constants/Tooltips';
import ZTypography from '../typography/ZTypography';
import toast from 'react-hot-toast';
import { Button } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        position: 'fixed',
        left: 20,
        bottom: 20,
        zIndex: 3000,
        background: '#fff',
        maxWidth: 400,
        borderRadius: 10,
        boxShadow: 'rgba(0, 0, 0, 14%) 5px 5px 18px 5px',
    },

    dialogTitle: {
        padding: '10px 10px 0 10px'
    },
    action: {
        paddingTop: 0
        // margin: "0.5% 3% 1.25% 0"
    },
    dialogMessage: {
        fontSize: "1rem",
        background: "rgba(87, 113, 219, 0.09)",
        padding: 20,
        color: 'rgb(13, 60, 97)',
        background: 'rgb(232, 244, 253)',
        padding: '6px 16px',

    },
    pageHeader: {
        paddingBottom: 0
    },
    unsubscribeMessage: {
        marginTop: 5
    },
}));
export default function ZCategoryDialog(props) {
    const classes = useStyles();


    return (
        <div>
            <div className={classes.dialogPaper}>
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
                    <ZHeader style={{ paddingBottom: 0 }} title={"Your Cookie Preferences"} align={"left"}></ZHeader>
                </DialogTitle>
                <DialogContent style={{ padding: 5, paddingLeft: 10 }}>
                    <ZTypography>This website uses cookies to ensure you get the best experience on our website.  <a target="_blank" href='https://trakzo.ai/cookies-policy/' >Learn more</a></ZTypography>
                </DialogContent>
                <DialogActions className={classes.action}>
                    <ZButton variant="contained" onClick={() => { props.handleClose() }} color="primary" name="Got it!"></ZButton>
                </DialogActions>
            </div>

        </div >
    );
}